import { Service, Testimonial, OrderCreateRequest, ApiResponse, AppConfig } from '../types';

// Use relative URL in production (same host), localhost in development
const API_BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3000');

export const api = {
  async getConfig(): Promise<AppConfig> {
    const response = await fetch(`${API_BASE_URL}/api/config`);
    const data: ApiResponse<AppConfig> = await response.json();
    if (!data.success || !data.data) {
      throw new Error('Failed to fetch configuration');
    }
    return data.data;
  },

  async getServices(): Promise<Service[]> {
    const response = await fetch(`${API_BASE_URL}/api/services`);
    const data: ApiResponse<Service[]> = await response.json();
    if (!data.success) {
      throw new Error(data.error || 'Failed to fetch services');
    }
    return data.data || [];
  },

  async getServiceById(serviceId: string): Promise<Service> {
    const response = await fetch(`${API_BASE_URL}/api/services/${serviceId}`);
    const data: ApiResponse<Service> = await response.json();
    if (!data.success) {
      throw new Error(data.error || 'Failed to fetch service');
    }
    return data.data!;
  },

  async getTestimonials(): Promise<Testimonial[]> {
    const response = await fetch(`${API_BASE_URL}/api/testimonials`);
    const data: ApiResponse<Testimonial[]> = await response.json();
    if (!data.success) {
      throw new Error(data.error || 'Failed to fetch testimonials');
    }
    return data.data || [];
  },

  async createOrder(orderData: OrderCreateRequest): Promise<ApiResponse> {
    const response = await fetch(`${API_BASE_URL}/api/orders`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(orderData),
    });
    const data: ApiResponse = await response.json();
    return data;
  },
};
